import { useGetExocetPdsToSimpleAssign } from '../../../../../../hooks/datarefs';
import { useInterventionCreation } from '../../context/interventionCreationContext';
import { NO_FILTERS, TableFilters, toQueryParams } from '../../../../../Tools/Table/filters';
import { AssignmentRow } from './assignmentRows';

/** La v2 rafraîchit par `invalidateQueries` : le jeton de cache-busting reste stable. */
const NO_CACHE_BUSTER = 0;

export type RequestsToAssignState = {
  rows: AssignmentRow[];
  count: number;
  isFetching: boolean;
  /** Voir `RequestsToQualifyState` : vrai tant qu'aucun compte n'est encore connu. */
  isInitialLoading: boolean;
};

/**
 * Demandes de l'étape Affectation. Encapsulé pour que le panneau et le compteur du
 * stepper partagent exactement la même clé de requête — donc le même cache, sans appel
 * en double.
 */
export function useRequestsToAssign(filters: TableFilters = NO_FILTERS): RequestsToAssignState {
  const { state } = useInterventionCreation();

  const { data, isFetching, isInitialLoading } = useGetExocetPdsToSimpleAssign(
    state.clientId === null ? '' : String(state.clientId),
    NO_CACHE_BUSTER,
    toQueryParams(filters)
  );

  return {
    rows: data?.results ?? [],
    count: data?.count ?? 0,
    isFetching,
    isInitialLoading
  };
}
